import CSVPreviewSection from '../CSVPreviewSection'

export default function BillingSummaryCSVPreviewBillingTypesSection() {}

BillingSummaryCSVPreviewBillingTypesSection.prototype = new CSVPreviewSection();

BillingSummaryCSVPreviewBillingTypesSection.prototype.init = function ( totalColumnsNum )
{
    CSVPreviewSection.prototype.init.call( this );
    this.totalColumnsNum = totalColumnsNum;
    return this;
};

BillingSummaryCSVPreviewBillingTypesSection.prototype.addRows = function ( tBody )
{
    var headerRow = this.createRow( "billingTypesSectionRow" );
    var dataRow = this.createRow( "billingTypesSectionRow" );

    for ( var i=0; i < this.totalColumnsNum - 3; i++)
    {
        ReportPreviewUtils.addEmptyCell( headerRow );
        ReportPreviewUtils.addEmptyCell( dataRow );
    }
    for ( i=0; i < 3; i++)
    {
        ReportPreviewUtils.addCell( headerRow, this.message("report.billing_type") );
    }
    this.addCell( dataRow, this.message("report.billing_summary.rate.csv", [SystemSettings.currencySign]) );
    
    this.addTimeValueCell( dataRow );
    this.addTimeValueCell( dataRow );

    this.addRow( tBody, headerRow );
    this.addRow( tBody, dataRow );
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/billingsummary/BillingSummaryCSVPreviewBillingTypesSection.js